import { render } from "./itinerary.vue?vue&type=template&id=01b0fdf4"
const script = {}
script.render = render

export default script